<template>
  <section>
     <form >
            <website ref="website"/>
            <div class="name">
            <div class="page section-header text-center">
              <h1 class="h1">LogIn</h1>
            </div>
    <div class="p-fluid  p-col-6 p-offset-3">
      <div class="p-field">
        <label for="firstname">Email</label>
        <InputText id="firstname" type="text"/>
      </div>
      <div class="p-field ">
        <label for="lastname">Password</label>
        <InputText id="lastname" type="text"/>
      </div>
      <div class="text-center hover-line">
        <!-- <Button label="SIGN IN"/> -->
        <Button  label="SIGN IN" style="width: 15%;" class="btn" >
</Button>
<p style="margin: 15px 0px 0px;">
  <a style="color: #555;" herf="#recover" id="RecoverPassword" > Forgot your password? </a>
   &nbsp; | &nbsp;
   <a style="color: #555;" href="/account/createAccount" id="customer_register_link"> Create account</a>
</p>
<!-- <div id="RecoverPasswordForm" class="hide">
				<div class="text-center">
					<h3>Reset your password</h3>
				</div>
				<div class="form-vertical"> <form method="post" action="/account/recover" accept-charset="UTF-8"><input type="hidden" name="form_type" value="recover_customer_password" /><input type="hidden" name="utf8" value="✓" />
					<p>We will send you an email to reset your password.</p>
					
					
					
					
					<label for="RecoverEmail" class="hidden">Email</label>
					<input type="email" value="" name="email" id="RecoverEmail" placeholder="Email" class="input-full" autocapitalize="off">
					<div class="text-center">
						<p>
							<input type="submit" class="btn" value="Submit">
						</p>
						<button type="button" id="HideRecoverPasswordLink" class="text-link">Cancel</button>
					</div>
      </div>
    </div> -->
      <!-- </div> -->

       <div id="RecoverPasswordForm" class="hide">
				<div class="text-center">
					<h3>Reset your password</h3>

          	<!-- <div class="form-vertical"> <form method="post" action="/account/recover" accept-charset="UTF-8"><input type="hidden" name="form_type" value="recover_customer_password" /><input type="hidden" name="utf8" value="✓" /> -->

          	<p>We will send you an email to reset your password.</p>
					
					
					
					
					<label for="RecoverEmail" class="hidden">Email</label>
					<input type="email" value="" name="email" id="RecoverEmail" placeholder="Email" class="input-full" autocapitalize="off">
          	<div class="text-center">
						<p>
							<input type="submit" class="btn" value="Submit">
						</p>
						<button type="button" id="HideRecoverPasswordLink" class="text-link">Cancel</button>
					</div>
				</div>
        </div>
    </div>
            </div>
            </div>
      <footerWebsite ref="footerWebsite"/>
     </form>
  </section>
</template>

<script>
import InputText from 'primevue/inputtext'
import Button from 'primevue/button'
import website from '../ecommerce/website.vue'
import footerWebsite from '../ecommerce/footerWebsite.vue'
export default {
  name: 'Login',
  components: {
    InputText,
    Button,
    website,
    footerWebsite
  }
}
</script>

<style scoped src="@../../../static/css/website.css">

</style>



// WEBPACK FOOTER //
// Login.vue?58c7239a